import React from 'react';
import GTMDataLayer from './gtm';

const FilterPRYears = (props) => {

  const handlePRYearsFilter = (e) => {
    if (e.target.value) {
      props.setFilters({...props.filters, year: e.target.value, page: 0});
    }
    GTMDataLayer({
      event: 'press_release_filter_year',
      pageUrl: location.href,
      filter_year: e.target.value
    });
  };

  return (
    <div className='filter-pr-years mb20'>
      <h3>{Drupal.t('Year')}</h3>
      <div>
        <select onChange={handlePRYearsFilter} defaultValue={props.selected} id="pr-years-filter">
          <option value='all'>{Drupal.t('All')}</option>
          {props.dataFilters.year.map((year, index) => (
            <option key={index} value={year}>{year}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterPRYears;